import type { Auth0ProviderOptions } from '@auth0/auth0-react'
import type { QueryClientConfig } from '@tanstack/react-query'

import {
  DEBUG,
  CARTO_API_BASE_URL,
  CARTO_CLIENT_ID,
  CARTO_ORGANIZATION_ID,
  CARTO_CONNECTION,
  GOOGLE_MAPS_API,
  GOOGLE_MAPS_ID,
  GOOGLE_GEOCODER_API,
  STATIC_ACCESS_TOKEN,
  setDynamicSettings,
} from '@/services/config'

export {
  DEBUG,
  CARTO_API_BASE_URL,
  CARTO_CLIENT_ID,
  CARTO_ORGANIZATION_ID,
  CARTO_CONNECTION,
  GOOGLE_MAPS_API,
  GOOGLE_MAPS_ID,
  GOOGLE_GEOCODER_API,
  STATIC_ACCESS_TOKEN,
  setDynamicSettings,
}

// Auth
export const AUTH: Auth0ProviderOptions = {
  domain: 'auth.carto.com',
  clientId: CARTO_CLIENT_ID,
  authorizationParams: {
    scope: [
      'profile',
      'email',
      'read:current_user',
      'read:connections',
      'read:maps',
      'read:account',
    ].join(' '),
    audience: 'carto-cloud-native-api',
    organization: CARTO_ORGANIZATION_ID,
  },
}

// i18n
export const SUPPORTED_LANGUAGES = ['en']

export const DEFAULT_LOCALE = SUPPORTED_LANGUAGES[0]!

export const i18nConfig = {
  // This is the list of languages your application supports
  supportedLngs: SUPPORTED_LANGUAGES,
  // This is the language you want to use in case
  // if the user language is not in the supportedLngs
  fallbackLng: SUPPORTED_LANGUAGES[0],
  // The default namespace of i18next is "translation", but you can customize it here
  defaultNS: 'translation',
  debug: DEBUG,
}

export const LOCALES_PATH = '/locales/{{lng}}/{{ns}}.json'

// React Query
export const REACT_QUERY_CONFIG: QueryClientConfig = {
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
    },
  },
}

export const REACT_QUERY_DEVTOOL_INITIAL_STATE = false

export const basemapsThatNeedLightBorderColor = [
  'darkMatter',
  'satellite',
  'hybrid',
]
